import * as React from 'react';
import { TTag } from './Tag.types';
import { Button } from 'components';
import { Add } from '@mui/icons-material';
import '../../AdminPanel.styles.scss';
import { MODALS } from 'store/contexts/ModalContext/modals';
import { useModals } from 'hooks/useModals';
import { TagsTable } from './components/TagsTable/TagsTable';

export const Tag: TTag = () => {
  const modals = useModals();

  const openModal = () => {
    modals.openModal(MODALS.ADMIN_TAG_ADD);
  };

  return (
    <div className="admin-entity">
      <div className="admin-entity__header">
        <div>
          <h4>Tags</h4>
        </div>
        <div className="admin-entity__header__buttons-contaier">
          <Button variant="contained" endIcon={<Add />} onClick={openModal}>
            Add tag
          </Button>
        </div>
      </div>
      <TagsTable />
    </div>
  );
};
